import React, { memo } from "react";
import Spacer from "../../Spacer";
import { useTranslation } from "react-i18next";
import { formatValidatedMeasurement } from "../../../utils/results/validatedRanges";
import { SHOW_FULL_RESULTS } from "../../../config/results";

function formatQuality(value, t) {
  if (value === "fail") return t("common.fail", "Fail");
  if (value === "pass") return t("common.pass", "Pass");
  return "--";
}

export default memo(function PostExertionResultRow({
  time,
  date,
  rr,
  rrMin,
  rrMax,
  rrQuality,
  onClick,
}) {
  const { t } = useTranslation();

  const rrIsBad = rrQuality === "fail";
  const metricTextClass = rrIsBad ? "!text-greyscale-3" : "!text-primary";

  const renderMetric = (label, value, unit = null) => (
    <div className="flex flex-col items-center justify-start min-w-0 self-stretch gap-0">
      <div className="w-full flex items-start justify-center text-center leading-tight">
        <p>
          {label} <span className="muted-text text-xs">{unit}</span>
        </p>
      </div>
      <div
        className={`title-text text-center whitespace-nowrap ${metricTextClass}`}
      >
        {value}
      </div>
    </div>
  );

  return (
    <div className="w-full flex flex-col">
      <button
        type="button"
        onClick={onClick}
        className={[
          "w-full text-left py-2 flex-col items-center gap-4 bg-transparent",
          onClick ? "cursor-pointer" : "cursor-default",
        ].join(" ")}
        disabled={!onClick}
      >
        <div>
          <p className="muted-text">
            {time} {date}
          </p>
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-2">
          {SHOW_FULL_RESULTS ? (
            <div className="grid grid-cols-3 gap-2 items-stretch">
              {renderMetric(
                t("result.postExertion.rrAverageLabel", "RR Avg"),
                formatValidatedMeasurement("rr", rr),
                t("result.resp.rrUnit", "bpm"),
              )}
              {renderMetric(
                t("result.postExertion.rrMinLabel", "RR Min"),
                formatValidatedMeasurement("rr", rrMin),
                t("result.resp.rrUnit", "bpm"),
              )}
              {renderMetric(
                t("result.postExertion.rrMaxLabel", "RR Max"),
                formatValidatedMeasurement("rr", rrMax),
                t("result.resp.rrUnit", "bpm"),
              )}
            </div>
          ) : (
            <div className="flex flex-col items-center text-center gap-1">
              <div className="muted-text text-xs leading-tight">
                {t(
                  "result.postExertion.respiratorySignalQuality",
                  "Respiratory Signal Quality",
                )}
              </div>
              <div
                className={`title-text whitespace-nowrap ${metricTextClass}`}
              >
                {formatQuality(rrQuality, t)}
              </div>
            </div>
          )}

          {rrIsBad ? (
            <div className="muted-text text-center text-xs leading-tight">
              {t("results.quality.low", "Low signal quality")}
            </div>
          ) : null}
        </div>
      </button>

      <Spacer />
    </div>
  );
});
